import { FunctionComponent } from 'react';

type HistoryIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const HistoryIcon: FunctionComponent<HistoryIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-920 -1050)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(920 1050)"
          fill={circleFill}
        />
        <g transform="translate(11317.5 564.125)">
          <path
            d="M21.687,24.749V21.483a4.687,4.687,0,0,0-1.373-3.314L17,14.854l3.314-3.314a4.687,4.687,0,0,0,1.373-3.314V6"
            transform="translate(-10396.459 487.5)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M4,6V8.225a4.687,4.687,0,0,0,1.373,3.314l3.314,3.314L5.373,18.168A4.687,4.687,0,0,0,4,21.483v3.267"
            transform="translate(-10390.228 487.5)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M15.291,37.6c0-1.042-3.646-2.6-3.646-2.6S8,36.562,8,37.6"
            transform="translate(-10392.146 473.604)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <line
            y2="1.042"
            transform="translate(-10380.5 503.916)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <line
            y2="1.042"
            transform="translate(-10380.5 506)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <line
            x2="15"
            transform="translate(-10388 493.5)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <line
            x2="15"
            transform="translate(-10388 512.25)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default HistoryIcon;
